export const fuelRegistryFieldConfigs = [
  // First row - 3 columns (Name, BDN ID, PoS ID)
  [
    {
      label: "",
      fieldName: "fuelRegId",
      col: 0,
      isMeta: false,
      required: true,
      display: false,
      isDropdown: false,
      alignRight: false,
      disabled: false
    },
    {
      label: "",
      fieldName: "vesselMstId",
      col: 0,
      isMeta: false,
      required: false,
      display: false,
      isDropdown: false,
      alignRight: false,
      disabled: false
    },
    {
      label: "Fuel Name",
      fieldName: "fuelName",
      col: 4,
      isMeta: false,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: false,
      disabled: false
    },
    {
      label: "BDN ID",
      fieldName: "BDN|ID",
      metaKey: "BDN|ID",
      col: 4,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: false,
      disabled: false
    },
    {
      label: "PoS ID",
      fieldName: "POS|ID",
      metaKey: "POS|ID",
      col: 4,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: false,
      disabled: false
    },
  ],
  // Second row - 4 columns (Mass, Energy Content, % Mass, % Energy)
  [
    {
      label: "Mass (MT)",
      fieldName: "QUANTITY|MT",
      metaKey: "QUANTITY|MT",
      col: 3,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "Energy Content (MJ)",
      fieldName: "ENERGY|CONTENT|MJ",
      metaKey: "ENERGY|CONTENT|MJ",
      col: 3,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "% Mass",
      fieldName: "PERCENT|MASS",
      metaKey: "PERCENT|MASS",
      col: 3,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "% Energy",
      fieldName: "PERCENT|ENERGY",
      metaKey: "PERCENT|ENERGY",
      col: 3,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
  ],
  // Third row - 4 columns (E, CO2eq WtT, RWD, CSlip)
  [
    {
      label: "E (gCO2eq/MJ)",
      fieldName: "E|VALUE|GCO2EQ|MJ",
      metaKey: "E|VALUE|GCO2EQ|MJ",
      col: 3,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "CO2eq WtT",
      fieldName: "CO2EQ|WTT",
      metaKey: "CO2EQ|WTT",
      col: 3,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: true
    },
    {
      label: "RWD",
      fieldName: "RWD",
      metaKey: "RWD",
      col: 3,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "EU CSlip (Y/N)",
      fieldName: "CSLIP",
      metaKey: "CSLIP",
      col: 3,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: true,
      options: [{ name: "Yes", code: "TRUE" }, { name: "No", code: "FALSE" }],
      alignRight: false,
      disabled: false,
      includeSelectOption: false
    },
  ],
  // Fourth row - 4 columns (IMO LCV, IMO CF CO2, UK MRV EF CO2, EU LCV)
  [
    {
      label: "IMO LCV (MJ/g)",
      fieldName: "IMO|LCV",
      metaKey: "IMO|LCV",
      col: 3,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "IMO CF CO2",
      fieldName: "IMO|CF|CO2",
      metaKey: "IMO|CF|CO2",
      col: 3,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "UK MRV EF CO2",
      fieldName: "UKMRV|EF|CO2",
      metaKey: "UKMRV|EF|CO2",
      col: 3,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "EU LCV (MJ/g)",
      fieldName: "EU|LCV",
      metaKey: "EU|LCV",
      col: 3,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
  ],
  // Fifth row - 3 columns (EU MRV EF CO2, CH4, N2O)
  [
    {
      label: "EU MRV EF CO2",
      fieldName: "EUMRV|EF|CO2",
      metaKey: "EUMRV|EF|CO2",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "EU MRV EF CH4",
      fieldName: "EUMRV|EF|CH4",
      metaKey: "EUMRV|EF|CH4",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "EU MRV EF N2O",
      fieldName: "EUMRV|EF|N2O",
      metaKey: "EUMRV|EF|N2O",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
  ],
  // Sixth row - 3 columns (EU ETS EF CO2, CH4, N2O)
  [
    {
      label: "EU ETS EF CO2",
      fieldName: "EUETS|EF|CO2",
      metaKey: "EUETS|EF|CO2",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "EU ETS EF CH4",
      fieldName: "EUETS|EF|CH4",
      metaKey: "EUETS|EF|CH4",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "EU ETS EF N2O",
      fieldName: "EUETS|EF|N2O",
      metaKey: "EUETS|EF|N2O",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
  ],
  // Seventh row - 3 columns (FEU EF CO2, CH4, N2O)
  [
    {
      label: "FEU EF CO2",
      fieldName: "FEU|EF|CO2",
      metaKey: "FEU|EF|CO2",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "FEU EF CH4",
      fieldName: "FEU|EF|CH4",
      metaKey: "FEU|EF|CH4",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "FEU EF N2O",
      fieldName: "FEU|EF|N2O",
      metaKey: "FEU|EF|N2O",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
  ],
  // Eighth row - 3 columns (UKETS EF CO2, CH4, N2O)
  [
    {
      label: "UKETS EF CO2",
      fieldName: "UKETS|EF|CO2",
      metaKey: "UKETS|EF|CO2",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "UKETS EF CH4",
      fieldName: "UKETS|EF|CH4",
      metaKey: "UKETS|EF|CH4",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
    {
      label: "UKETS EF N2O",
      fieldName: "UKETS|EF|N2O",
      metaKey: "UKETS|EF|N2O",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: false
    },
  ],
  // Ninth row - 1 column (UK CSLIP)
  [
    {
      label: "UK CSlip (Y/N)",
      fieldName: "UKCSlip",
      metaKey: "UKCSLIP",
      col: 4,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: true,
      options: [{ name: "Yes", code: "TRUE" }, { name: "No", code: "FALSE" }],
      alignRight: false,
      disabled: true,
      includeSelectOption: false
    },
    
  ],
];

export const blendFuelRegistryFieldConfigs = [
     [

    {
      label: "Fuel Code",
      value: "Blend",
      fieldName: "fuelType",
      col: 4,
      isMeta: false,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: false,
      disabled: true
    },
    {
      label: "Fuel Name",
      fieldName: "fuelName",
      col: 4,
      isMeta: false,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: false,
      disabled: false
    },
    {
      label: "BDN ID",
      fieldName: "BDN|ID",
      metaKey: "BDN|ID",
      col: 4,
      isMeta: true,
      required: true,
      display: true,
      isDropdown: false,
      alignRight: false,
      disabled: false
    },
  ],
  [
    {
      label: "IMO CF CO2",
      fieldName: "IMO|CF|CO2",
      metaKey: "IMO|CF|CO2",
      col: 4,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: true
    },
    {
      label: "UK MRV EF CO2",
      fieldName: "UKMRV|EF|CO2",
      metaKey: "UKMRV|EF|CO2",
      col: 4,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: true,
      disabled: true
    },
    {
      label: "Blend Code",
      fieldName: "BLEND|CODE",
      metaKey: "BLEND|CODE",
      col: 4,
      isMeta: true,
      required: false,
      display: true,
      isDropdown: false,
      alignRight: false,
      disabled: true
    },
    
  ],

  
];

// constants/fuelTypes.js
export const FUEL_CATEGORIES = {
    BLEND: "Blend",
    BIOFUEL: "Biofuel",
    E_FUEL: "e-Fuel",
    FOSSIL: "Fossil",
    OTHER:'Other'
};

export const NA_FIELDS = {
    [FUEL_CATEGORIES.E_FUEL]: ['QUANTITY|MT', 'ENERGY|CONTENT|MJ', 'PERCENT|ENERGY', 'PERCENT|MASS'],
    [FUEL_CATEGORIES.FOSSIL]: ['QUANTITY|MT', 'ENERGY|CONTENT|MJ', 'PERCENT|ENERGY', 'PERCENT|MASS', 'E|VALUE|GCO2EQ|MJ'],
    [FUEL_CATEGORIES.BIOFUEL]: ['PERCENT|ENERGY', 'PERCENT|MASS'],
};

export const DISABLED_FIELDS = {
    [FUEL_CATEGORIES.E_FUEL]: ['QUANTITY|MT', 'ENERGY|CONTENT|MJ','fuelName'],
    [FUEL_CATEGORIES.FOSSIL]: ['QUANTITY|MT', 'ENERGY|CONTENT|MJ', 'PERCENT|ENERGY', 'PERCENT|MASS', 'E|VALUE|GCO2EQ|MJ','fuelName'],
    [FUEL_CATEGORIES.BIOFUEL]:['fuelName','EU|LCV'],
    [FUEL_CATEGORIES.BLEND]: ['IMO|CF|CO2','UKMRV|EF|CO2', 'BLEND|CODE']
};

export const ALWAYS_DISABLED_FIELDS = ['CO2EQ|WTT', 'PERCENT|ENERGY', 'PERCENT|MASS','fuelType','RWD','CSLIP','UKCSLIP'];

export const FUEL_CLASSIFICATIONS = Object.values(FUEL_CATEGORIES).map((value) => ({
    label: value,
    value,
}));


export const OVERWRITABLE_FIELDS = [
  "EUMRV|EF|CO2",
  "EUMRV|EF|CH4",
  "EUMRV|EF|N2O",
  "EUETS|EF|CO2",
  "EUETS|EF|CH4",
  "EUETS|EF|N2O",
  "FEU|EF|CO2",
  "FEU|EF|CH4",
  "FEU|EF|N2O",
  "UKMRV|EF|CO2",
  "IMO|CF|CO2",
  "IMO|LCV",
  "EU|LCV",
  "UKETS|EF|CH4",
  "UKETS|EF|N2O",
  "UKETS|EF|CO2",
];

export const BLENDREQUIREDFIELDS = [
  "EUMRV|EF|CO2",
  "EUMRV|EF|CH4",
  "EUMRV|EF|N2O",
  "EUETS|EF|CO2",
  "EUETS|EF|CH4",
  "EUETS|EF|N2O",
  "FEU|EF|CO2",
  "FEU|EF|CH4",
  "FEU|EF|N2O",
  "UKMRV|EF|CO2",
  "IMO|CF|CO2",
  "QUANTITY|MT",
  "ENERGY|CONTENT|MJ",
  "E|VALUE|GCO2EQ|MJ",
  "UKETS|EF|CH4",
  "UKETS|EF|N2O",
  "UKETS|EF|CO2",
];

export const BLEND_PARENT_META_KEYS = [
    "BDN|ID",
    "IMO|CF|CO2",
    "UKMRV|EF|CO2",
    "BLEND|CODE",
    "QUANTITY|MT",
];

export const EU_FIELD = {
  label: "eᵤ (gCO2eq/MJ)",
  fieldName: "EU|VALUE",
  metaKey: "EU|VALUE",
  col: 3,
  isMeta: true,
  required: true,
  display: true,
  isDropdown: false,
  alignRight: true,
  disabled: false
};